import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import {DrawChart, ChartIncludeColumn,ChartStackColumn} from "./Chart/ChartInclude";
import './Home.css';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { serviceSuperviewUserCount, serviceSuperviewUserProgramCount, serviceSuperviewUserDivisionPracticeCount, serviceSuperviewUserDivisionDateCount, serviceDivisionPractice, serviceSuperviewInclinicCall } from "../Services/Service";
import { DateRangeComp } from './DatePicker/CustomRangeDatePicker';
import format from 'date-fns/format';
import Dropdown from './Dropdown/Dropdown';

function HomeSuperAdmin() {

    
    const [userData, setUserData ] = useState({'onboarded':0,'notonboarded':0, 'total':0,'loggedIn':0,'inclinic':0,'completedCalls':0 });
    const [seriesGraph, setSeriesGraph ] = useState({'program_graph_series':{}, divisionCategory:[],divisionSeries:[], divisionDateCategory:[],divisionDateSeries:[],inclinicCallSeries:[] });
    const [startRange, setStartRange] = useState('');
    const [endRange, setEndRange] = useState('');
    const[dateFilter,setDateFilter] = useState([]);
    const[divisionClinicFilter,setDivisionClinicFilter] = useState({division:[],clinic:[]});
    const [divisionPracticeData, setDivisionPracticeData] = useState([]);
    const [graphDuration, setGraphDuration] = useState('Daily ');

    useEffect(() => {
        filterData();
    },[startRange,endRange,divisionClinicFilter]);

    useEffect(() => {
        fetchDivsionPractice();
      }, []);
      let divisionArr=[];let clinicArr=[];
    const assignObjectPaths = (obj, stack) => {
        
        Object.keys(obj).forEach(k => {
            const node = obj[k];
            if(node.type=='parent'){
                divisionArr = appendUniqueValue(divisionArr,node.value);
            }
            if(node.type=='child'){
                clinicArr = appendUniqueValue(clinicArr,node.value);
            }
            
            if (typeof node === "object") {
            node.path = stack ? `${stack}.${k}` : k;
            assignObjectPaths(node, node.path);
            }
        });
        
    };
    function appendUniqueValue(arr, value) {
        const existingIndex = arr.findIndex(item => item === value);
        if (existingIndex !== -1) {
          arr[existingIndex] = value;
        } else {
          arr.push(value);
        }
        return arr; 
      }
    const fetchDivsionPractice = async () => {        
    await serviceDivisionPractice()
        .then((res) => {
            console.log(res.data.data);
            
            assignObjectPaths(res.data.data);
            console.log(divisionArr);
            console.log(clinicArr);
            setDivisionClinicFilter(prevState => ({...prevState,clinic: clinicArr, division:divisionArr }));
            setDivisionPracticeData(res.data.data);
        });
    }
    const filterData = () => {
       
        fetchSuperviewUserCount();  
        fetchSuperviewUserProgramCount();
        fetchSuperviewUserDivisionCount();
        fetchSuperviewUserDivisionDateCount();
        fetchSuperviewInclinicCall();
    }
    const fetchSuperviewUserCount = async () => {   
             
        await serviceSuperviewUserCount(startRange,endRange,divisionClinicFilter)
            .then((res) => {
                setUserData(prevState => ({ ...prevState, onboarded: parseInt(res.data.data[0].onboardedUser),total: parseInt(res.data.data[0].total),loggedIn: parseInt(res.data.data[0].loggedInUser), notonboarded: parseInt(res.data.data[0].notonboardedUser) , inclinic: parseInt(res.data.data[0].inclinic),completedCalls: parseInt(res.data.data[0].completedCalls)}));
            });
    } 
    const fetchSuperviewUserProgramCount = async () => {        
        await serviceSuperviewUserProgramCount(startRange,endRange,divisionClinicFilter)
            .then((res) => {
                setSeriesGraph(prevState => ({ ...prevState, program_graph_series:res.data.data.series }));
            });
    }
    const fetchSuperviewUserDivisionCount = async () => {        
        await serviceSuperviewUserDivisionPracticeCount(startRange,endRange,divisionClinicFilter)
            .then((res) => {
                setSeriesGraph(prevState => ({ ...prevState, divisionCategory:res.data.data.category, divisionSeries:res.data.data.series }));
            });
    }
    const fetchSuperviewUserDivisionDateCount = async () => {        
        await serviceSuperviewUserDivisionDateCount(startRange,endRange,divisionClinicFilter)
            .then((res) => {
                setSeriesGraph(prevState => ({ ...prevState, divisionDateCategory:res.data.data.category, divisionDateSeries:res.data.data.series }));
                setGraphDuration(res.data.graphDuration)
            });
    }
    const fetchSuperviewInclinicCall = async () => {        
        await serviceSuperviewInclinicCall(startRange,endRange,divisionClinicFilter)
            .then((res) => {
                setSeriesGraph(prevState => ({ ...prevState, inclinicCallSeries:res.data.data.series }));
            });
    }

    
    const getData = (data)=>{
        let start = format(data[0].startDate,"yyyy-MM-dd");
        let end = format(data[0].endDate,"yyyy-MM-dd");      
        setStartRange(start);
        setEndRange(end);
      } 

    const updateParentChildDropdown = (index, checkedValue,type,childindex) => {
        if(type=='parent'){
            
            const chld = divisionPracticeData[index].children.map((child)=> {
                // return child.value ;
                if(checkedValue){
                    setDivisionClinicFilter(prevState => ({...prevState,clinic: [...prevState.clinic, child.value] }));
                }else{
                    setDivisionClinicFilter(prevState => {
                        const updatedClinic = prevState.clinic.filter(d => d !== child.value);
                        return { ...prevState, clinic: updatedClinic };
                      });
                }
                
            });
            // console.log(chld);
           

            const updatedData = divisionPracticeData.map((parent, parentIndex) => {
                    if (parentIndex == index) {
                        const updatedChildren = parent.children.map((child) => ({
                        ...child,
                        checked: checkedValue,
                        }));
 
                        return {
                        ...parent,
                        checked: checkedValue,
                        expanded: false,
                        children: updatedChildren,
                        };
                    }else{
                        return {
                            ...parent,
                            expanded: false,
                        };
                    }
                    
            // return parent;
            });
            console.log(updatedData);
            setDivisionPracticeData(updatedData); // Update the state with the modified array
        }else{
            if (type == 'child') {
                const updatedData = [...divisionPracticeData]; // Create a copy of the original data
                updatedData[index].children[childindex].checked = checkedValue;                
                const uncheckedChild = updatedData[index].children.find(child => !child.checked);
                if(uncheckedChild){//mark parent
                    updatedData[index].checked = false;
                }else{
                    updatedData[index].checked = true;
                    setDivisionClinicFilter(prevState => ({...prevState,division: [...prevState.division, updatedData[index].value] }));
                }
                // updatedData[index].expanded = true;
                const updatedData1 = updatedData.map((item, i) => {
                    if (index == i) { // Skip updating 'expanded' for key 3 node (index 2)
                        return { ...item, expanded: true };
                    } else {
                      return { ...item, expanded: false };
                    }
                  });
                
                setDivisionPracticeData(updatedData1); 
            }
        }
    };
    
    const getDropdownData = (currentNodeLabel,currentNode) => {
        const currentVal = currentNode.value;
        const currentPath = currentNode.path;

        if(currentNodeLabel=='parent'){
            if(currentNode.checked){
                updateParentChildDropdown(currentPath, true,'parent','');
                setDivisionClinicFilter(prevState => ({...prevState,division: [...prevState.division, currentVal] }));
            }else{
                updateParentChildDropdown(currentPath, false,'parent','');
                setDivisionClinicFilter(prevState => {
                    const updatedDivision = prevState.division.filter(d => d !== currentVal);
                    return { ...prevState, division: updatedDivision };
                  });
            }
        }

        if(currentNodeLabel=='child'){
            let pathSplit = currentPath.split('.');
            let parentKey = pathSplit[0];
            let childKey = pathSplit[2];
            if(currentNode.checked){
                updateParentChildDropdown(parentKey, true,'child',childKey);
                setDivisionClinicFilter(prevState => ({...prevState,clinic: [...prevState.clinic, currentVal] }));
            }else{
                updateParentChildDropdown(parentKey, false,'child',childKey);
                setDivisionClinicFilter(prevState => {
                    const updatedClinic = prevState.clinic.filter(d => d !== currentVal);
                    return { ...prevState, clinic: updatedClinic };
                  });
                  const parentVal = divisionPracticeData[parentKey].value;
                  setDivisionClinicFilter(prevState => {
                    const updatedDivision = prevState.division.filter(d => d !== parentVal);
                    return { ...prevState, division: updatedDivision };
                  });
            }
        }
      };
    return (
        <>
        <section className='projects-section'>
            <div className="row">
                <div className="col-md">
                    <h1 className='title'>Super Admin Overview</h1>
                </div>
                <div className='col-md-auto pe-0'>
                    <Dropdown data={divisionPracticeData} onChange={getDropdownData}/>
                </div>
                <div className='col-md-auto pe-1'>
                    <DateRangeComp typeofdate="blank" filterParam={{'smsStartFilter':startRange}} onClick={getData} /> 
                </div>
                <div className='col-md-auto ps-0'>
                <button type="button"  className="btn btn-success btn-sm" onClick={(e)=>{setStartRange(''); setEndRange('');fetchDivsionPractice(); setDivisionClinicFilter({division:[],clinic:[]}); }}>Clear</button>
                </div>
            </div>

            <div className="row mb-10 px-2">

                {/* <div className="col-6 col-md-2 mt-3">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/88760_1681801347.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.onboarded}</h1>
                        <h2 className='subtitle'>Total Active Users</h2>
                    </div>
                </div> */}

                {/* <div className="col-6 col-md-2 mt-3">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/24762_1681803043.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.onboarded + userData.notonboarded}</h1>
                        <h2 className='subtitle'>Uploaded Users</h2>
                    </div>
                </div> */}

                <div className="col-6 col-md-2 mt-3 px-1">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/13688_1684235547.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.total}</h1>
                        <h2 className='subtitle'>Total Accounts <br/>created</h2>
                    </div>
                </div>

                <div className="col-6 col-md-2 mt-3 px-1">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/88760_1681801347.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.total-userData.loggedIn}</h1>
                        <h2 className='subtitle'>Not logged in <br/> Patients</h2>
                    </div>
                </div>

                <div className="col-6 col-md-2 mt-3 px-1">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/59789_1681803187.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.loggedIn-userData.onboarded}</h1>
                        <h2 className='subtitle'>Partial patient<br/>registration</h2>
                    </div>
                </div>

                <div className="col-6 col-md-2 mt-3 px-1">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/93035_1684235616.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.onboarded}</h1>
                        <h2 className='subtitle'>Active <br/>Patients</h2>
                    </div>
                </div>
                
                <div className="col-6 col-md-2 mt-3 px-1">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/76526_1681803201.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.inclinic}</h1>
                        <h2 className='subtitle'>In-clinic <br/>Appointments</h2>
                    </div>
                </div>
                <div className="col-6 col-md-2 mt-3 px-1">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/33669_1684235686.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.completedCalls}</h1>
                        <h2 className='subtitle'>In-clinic <br/>completed Appointments</h2>
                    </div>
                </div>

            </div>
            
            <div className='row'>

                <div className='col-md-6 pe-5 line-r'>
                    <div className="row">
                        <div className="col-8"> <h1 className='title'>Programs</h1></div>
                    </div>
                    
                    <DrawChart
                        series={seriesGraph.program_graph_series}
                        chartType = 'pie'
                    />
                </div>
                <hr className='line d-sm-none' />
                <div className='col-md-6 ps-5'>
                    <div className="row">
                        <div className="col-12"><h1 className='title'>Division-wise Categorisation</h1></div>
                    </div>
                    
                    <ChartStackColumn
                        series={seriesGraph.divisionSeries}
                        category ={seriesGraph.divisionCategory}
                        chartType = 'column'
                    />
                </div>
                
                <hr className='line' />
                <div className='col-md-6 pe-5 line-r'>
                    <div className="row">
                        <div className="col-8"><h1 className='title'>{graphDuration}Categorisation</h1></div>
                    </div>
                    <ChartIncludeColumn
                        series={seriesGraph.divisionDateSeries}
                        category ={seriesGraph.divisionDateCategory}
                        chartType = 'column'
                    />
                </div>
                <hr className='line d-sm-none' />
                <div className='col-md-6 ps-5'>
                    <div className="row">
                        <div className="col-md-12"><h1 className='title'>In-clinic Appointments</h1></div>
                    </div>
                    <DrawChart
                        series={seriesGraph.inclinicCallSeries}
                        chartType = 'pie'
                    />
                </div>
                <hr className='line' />
                <div className='col-md-6 pe-5 line-r'>
                    <div className="row">
                        <div className="col-8"><h1 className='title'>{graphDuration}Gender</h1></div>
                    </div>
                    Add Graph
                </div>
                <hr className='line d-sm-none' />
                <div className='col-md-6 ps-5'>
                    <div className="row">
                        <div className="col-md-12"><h1 className='title'>Age</h1></div>
                    </div>
                    Add Graph
                </div>

                <hr className='line' />
                <div className='col-md-6 pe-5 line-r'>
                    <div className="row">
                        <div className="col-8"><h1 className='title'>{graphDuration}Call Details</h1></div>
                    </div>
                    Add Graph
                </div>
                <hr className='line d-sm-none' />
                <div className='col-md-6 ps-5'>
                    <div className="row">
                        <div className="col-md-12"><h1 className='title'>Message Details</h1></div>
                    </div>
                    Add Graph
                </div>
            </div>

        </section>
        </>
    );
}
export default HomeSuperAdmin;
